<!--
	TreeViewers.svelte

    4/29 - attempting to simplify the SearchPage

    Contains only the taxonomy trees
-->

<script>
    import { onMount } from 'svelte';
    import { TCARE_TAX_1, OPEN_ELIG_2022, DEMOGRAPHICS } from '../../common/taxonomy-classes';

    // TCARE components
    import TreeViewer from './TreeViewer.svelte';


    // 5/11 - NEW ARCHITECTURE
    export let store;                                               // Search or Service object

    $: allNodes1 = $store.taxonomies[TCARE_TAX_1].forest.items;     // must be reactive!
    let name1 = $store.taxonomies[TCARE_TAX_1].name;
    let color1 = $store.taxonomies[TCARE_TAX_1].color;

    $: allNodes2 = $store.taxonomies[OPEN_ELIG_2022].forest.items;
    let name2 = $store.taxonomies[OPEN_ELIG_2022].name;
    let color2 = $store.taxonomies[OPEN_ELIG_2022].color;

    $: allNodes3 = $store.taxonomies[DEMOGRAPHICS].forest.items;
    let name3 = $store.taxonomies[DEMOGRAPHICS].name;
    let color3 = $store.taxonomies[DEMOGRAPHICS].color;

    onMount(() => {
        // console.log('');
        // console.log('TreeViewers onMount');
    })

    // the node .isSelected has already been set in TreeViewerNode handler
    // must reset the store to trigger UI and SearchChips reactive update
    const onTreeNodeClick = (treeNode) => {
        $store = $store;
        // console.log($store);
    }


</script>

<style>

    .tree-viewers {
        /* border: 1px solid red; */
    }

    .taxonomy-name {
        font-size: 1.5em;
        padding: 5px 10px;
        margin-bottom: 10px;
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="tree-viewers">
    <div class="flex-row fluid ai-start">
        <div class="flex-block w-33 tree-block">
            <div class="taxonomy-name" style={'color: ' + color1}>{name1}</div>
            <TreeViewer tree={allNodes1} onNodeClick={onTreeNodeClick}/>
        </div>

        <div class="flex-block w-33 tree-block">
            <div class="taxonomy-name" style={'color: ' + color2}>{name2}</div>
            <TreeViewer tree={allNodes2} onNodeClick={onTreeNodeClick}/>
        </div>

        <div class="flex-block w-33 tree-block">
            <div class="taxonomy-name" style={'color: ' + color3}>{name3}</div>
            <TreeViewer tree={allNodes3} onNodeClick={onTreeNodeClick}/>
        </div>        
    </div>
</div>
